export const appId = "postnord-labels-dev";

export function initApp() {
  EcwidApp.init({
    app_id: appId,
    autoloadedflag: true,
    autoheight: true,
  });
  return appId;
}

// append query string of url to back links
export function bindNavLinks() {
  const indexOfQs = location.href.indexOf("?");
  if (indexOfQs !== -1) {
    const qs = location.href.substring(indexOfQs);
    $(".nav-link").each(function () {
      const $this = $(this);
      $this.attr("href", $this.attr("href") + qs);
    });
  }
}

export function getEcwidUrl(path, storeData) {
  const sep = path.indexOf("?") === -1 ? "?" : "&";
  return `https://app.ecwid.com/api/v3/${storeData.store_id}${path}${sep}token=${storeData.access_token}`;
}

export function postWindow(url, data) {
  const viewName = "postForm-" + Date.now();
  const form = document.createElement("form");
  form.setAttribute("method", "post");
  form.setAttribute("action", url);
  form.setAttribute("target", viewName);

  Object.keys(data).forEach((key) => {
    const hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", typeof data[key] === "string" ? data[key] : JSON.stringify(data[key]));
    form.appendChild(hiddenField);
  });
  document.body.appendChild(form);
  window.open("", viewName);
  form.submit();
}

export function abbreviateUnit(unit) {
  switch (unit.toUpperCase()) {
    case "CARAT":
      return "ct";
    case "GRAM":
      return "g";
    case "OUNCE":
      return "oz";
    case "POUND":
      return "lb";
    case "KILOGRAM":
      return "kg";
    default:
      return unit;
  }
}

export function validateInput($input) {
  const req = $input.data("req");
  const val = $input.val().trim();
  const valid = req ? new RegExp(req).test(val) : true;
  const $fieldSet = $input.closest(".fieldset");
  $fieldSet.toggleClass("has-error", !valid);
  $(".field__error", $fieldSet).toggle(!valid);
  return valid;
}

export function setInputValue($input, val) {
  $input.val(val);
  $input.closest(".field").toggleClass("field--filled", !!val);
}

export function getInputValue($input) {
  return $input.val().trim();
}

export function getAccountStatus(id, storeId) {
  if (!id) {
    return Promise.resolve({ hasAccount: false, hasProductionNumber: false });
  }
  return new Promise((resolve) => {
    $.get(`/account?id=${id}&storeId=${storeId}`, (account) => {
      const hasAccount = !!account;
      const hasProductionNumber = account && account.hasProductionNumber;
      resolve({ hasAccount, hasProductionNumber });
    }).fail(function () {
      resolve({ hasAccount: false, hasProductionNumber: false });
    });
  });
}

export function localize(trans) {
  $(".localized").each(function () {
    const translationKey = $(this).data("translation");
    $(this).text(trans[translationKey]);
  });
}

export function mergeTranslations(...args) {
  return args.reduce((a, b) => Object.keys(a).reduce((acc, key) => ({ ...acc, [key]: { ...a[key], ...b[key] } }), {}));
}

export function bindCurrencyFieldset({ currencyPrefix, currencySuffix }) {
  $(".fieldset-currency").each(function () {
    const $this = $(this);
    if (currencyPrefix) {
      $this.addClass("fieldset--with-prefix");
    }
    if (currencySuffix) {
      $this.addClass("fieldset--with-suffix");
    }
    $(".fieldset__field-prefix", $this).text(currencyPrefix);
    $(".fieldset__field-suffix", $this).text(currencySuffix);
  });
}
